import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

export const useViewport = () => {
  const [isDesktop, setIsDesktop] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const handleWindowResize = () =>
      setIsDesktop(theme.breakpoints.lg < window.innerWidth);
    handleWindowResize();

    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, [theme]);

  return { isDesktop };
};
